import React, { Component } from "react";
import {
	Form,
	Input,
	Button,
	Checkbox,
	Select,
	message,
	notification,
	Icon,
	Modal
} from "antd"; /* 2. 引入所需的antd组件 */
import "./login.scss"; /* 引入当前文件夹下的login.scss样式文件 */
import axios from "axios";
import { loginFn, getUserInfo, operaterLogin } from "@/request/api";
import { initWebSocket, sendMessage, receiveMessage } from "@/request/websocket";
import { requestErrorLog } from "@/common/util";

const justifyMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const { Option } = Select;
class Login extends Component {
	formRef = React.createRef();
	constructor(props) {
		super(props);
		this.state = {
			hospitalData: [],
			hospitalNameList: [],
			shouldClick: true,
			loginType: localStorage.getItem("loginType") === '1' ? 1 : 0,//0：医联体登录；1：运营商登录
		};
	}

	async componentDidMount() {
		var tempAccount = localStorage.getItem("remoteLoginAccount");
		var tempPassword = localStorage.getItem("remoteLoginPassword");
		window.localStorage.removeItem("menuList");
		window.localStorage.removeItem("userInfo");
		this.initHospitalList();
		// 账号
		if (tempAccount) {
			this.props.form.setFieldsValue({
				remoteLoginAccount: tempAccount
			});
		}
		// 密码
		if (tempPassword) {
			this.props.form.setFieldsValue({
				remoteLoginPassword: tempPassword
			});
		}
		// 心电图机下载
		if ("WebSocket" in window && !justifyMobile) {
			var loginWs = new WebSocket("ws://localhost:8181");
			let that = this;
			loginWs.onerror = (evt) => {
				notification.info({
					message: "下载 PYAnalysis 服务控件",
					description: (
						<p className="caExe" onClick={that.downloadApp}>
							您还未安装，请点击链接下载并运行
						</p>
					),
					duration: 0
				});
			};
		}
		if (window.g.updateMain) {
			const content = (
				<div className="updateContentBox">
					<div className="updateMain" ref={(el) => (this.updateMain = el)}></div>
					<div className="updateText">
						<span>更新内容：</span>
						<div className="textBox" ref={(el) => (this.updateText = el)}></div>
						{/* <Input.TextArea autoSize={{ maxRows: 6, minRows: 6 }} value={window.g.updateText} /> */}
					</div>
				</div>
			);
			Modal.warning({
				title: (
					<p>
						<Icon type="warning" theme="filled" />
						<span>{window.g.updateTitle}</span>
					</p>
				),
				content: content,
				icon: null,
				centered: true,
				className: "updateContainer",
				width: "650px",
				okText: "我知道了"
			});
			setTimeout(() => {
				if (this.updateMain) {
					this.updateMain.innerHTML = window.g.updateMain;
				}
				if (this.updateText) {
					this.updateText.innerHTML = window.g.updateText;
				}
			}, 0);
		}
	}

	downloadApp = () => {
		let params = {
			Token: null,
			Command: "E00041",
			Param: { Type: "FileService" },
			RequestModel: null
		}
		axios
			.post(window.g.baseURL + "/api/websiteecg", params)
			.then((res) => {
				if (res.data.Status === 1) {
					// const addr = res.config.baseURL;
					const data = res.data.Result;
					window.location.href = window.g.baseURL + data;
				}
			}).catch(err => {
				requestErrorLog('', '获取中间件报错:' + JSON.stringify(params), 0, false)
			});
	};

	initHospitalList = () => {
		// 医院列表
		let params = {
			Token: null,
			Command: "E00041",
			Param: { Type: "Hospital" },
			RequestModel: null
		}
		axios.post(window.g.baseURL + "/api/websiteecg", params)
			.then((res) => {
				if (res && res.data.Status === 1) {
					const data = res.data.Result;
					this.setState({
						hospitalData: data
					});
				} else {
					message.error("请检查网络连接");
				}
			}).catch(err => {
				requestErrorLog('', '登录请求医院列表报错:' + JSON.stringify(params), 0, false)
			});
	};

	initUserInfoData() {
		// 用户基本信息
		getUserInfo().then((res) => {
			if (res && res.Status === 1) {
				const userInfo = res.Result;
				for (var i = 0; i < userInfo.length; i++) {
					const userInfoData = userInfo[i];
					localStorage.setItem("userInfo", JSON.stringify(userInfoData));
					let RedirectUrl = this.props.location.state ? this.props.location.state.from.pathname : "/pages";
					// 登陆成功之后的跳转
					this.props.history.push(RedirectUrl);
				}
			} else {
				requestErrorLog('', '获取用户信息报错', 0, true)
			}
		});
	}

	handleLoginSubmit = () => {
		if (this.state.loginType === 0) {//医联体登录
			this.props.form.validateFields(async (err, values) => {
				if (!err) {
					let param = {
						LOGIN_CODE: values.remoteLoginAccount, //用户名
						PASSWORD: values.remoteLoginPassword, // 密码
						HOSPITAL_CODE: values.loginHospitalName //医院code
					};
					if (window.g.CA) {
						if (!this.state.shouldClick) return;
						this.setState({ shouldClick: false });
						await initWebSocket();
						let params = { TYPE: "HOLTER", PARAM: "GXCA_LOGIN" };
						sendMessage(params);
						receiveMessage((data) => {
							if (data.RETURN_VALUE === "验证CA") {
								if (data.RETURN_MSG === "验证通过") {
									this.loginFunction(param, values);
								} else {
									if (data.RETURN_MSG) message.error(data.RETURN_MSG);
								}
								this.setState({ shouldClick: true });
							}
						});
					} else {
						this.loginFunction(param, values);
					}
				}
			});
		} else if (this.state.loginType === 1) {//运营商登录
			this.props.form.validateFields(async (err, values) => {
				if (!err) {
					let param = {
						OPERATION_PHONE: values.remoteLoginAccount, //用户名
						PASSWORD: values.remoteLoginPassword, // 密码
					};
					//运营商登录接口需要写token
					operaterLogin(param).then((res) => {//保存运营人员登录信息
						if (res && res.Status === 1) {
							let resObj = res.Result
							if (resObj === -1) {
								message.error("用户不存在");
								return;
							}
							if (resObj === -2) {
								message.error("用户名或密码错误");
								return;
							}
							if (resObj === -3) {
								message.error("登陆失败，该账号未关联医疗机构");
								return;
							}
							localStorage.setItem("loginType", '1');
							localStorage.setItem("token", resObj.Token);
							localStorage.setItem("operaterInfo", JSON.stringify(resObj));

							localStorage.setItem("remoteLoginAccount", values.remoteLoginAccount ? values.remoteLoginAccount : ""); // 用户名

							if (values.remoteLoginRemember) {
								localStorage.setItem("remoteLoginPassword", values.remoteLoginPassword ? values.remoteLoginPassword : ""); // 记住密码
							} else {
								localStorage.removeItem("remoteLoginPassword"); // 不记住密码
							}
							this.props.history.push('/siderPage?key=19')
						} else {
							message.warn('登陆失败')
							requestErrorLog('', '运营商登录报错', 0, true)
						}
					})
				}
			});

		}
	};
	loginFunction = (params, values) => {
		loginFn(params).then((res) => {
			this.setState({ shouldClick: true });
			if (res && res.Status === 1) {
				if (res.Result === -2) {
					return message.error("用户名或密码错误");
				}
				if (res.Result === -3) {
					return message.error("用户已停用");
				}
				if (res.Result === -5) {
					return message.error("请联系管理员设置分组");
				}
				if (res.Result === -6) {
					return message.error("所属医院已停用");
				}
				if (res.Result === -7) {
					return message.error("所属医院代理商不存在");
				}
				// 将真实姓名保存
				let item = res.Result;
				///只要出现重新登陆时，就把新建患者时保存的信息清除掉
				localStorage.removeItem("PATIENT_SOURCE"); //患者来源patientsourse
				localStorage.removeItem("EXAM_CLASS"); //检查类型checkTypeCode
				localStorage.removeItem("EXAM_CLASSName"); //检查类型checkTypeCName
				localStorage.removeItem("ITEM_NAME"); //检查项目
				localStorage.removeItem("ITEM_CODE"); //检查项目
				localStorage.removeItem("REQ_DEPT_NAME"); //申请科室
				localStorage.removeItem("REQ_DEPT_CODE"); //申请科室
				localStorage.removeItem("EXAM_SUB_CLASS"); //检查子类
				localStorage.removeItem("REQ_DOCTOR_CODE"); //申请医生
				localStorage.removeItem("BILLING_DOCTOR"); //开单医生
				localStorage.setItem("loginRealId", item.USER_UID); //用户id
				localStorage.setItem("statisticalType", item.STATISTICAL_TYPE); // 统计类型
				localStorage.setItem("menuList", JSON.stringify(item.MENUList)); // 菜单权限
				localStorage.setItem("roleList", JSON.stringify(item.RoleData)); // 权限
				localStorage.setItem("QUERY_ALL", JSON.stringify(item.QUERY_ALL)); // 权限

				localStorage.setItem("datagroup", item.DATA_GROUP ? item.DATA_GROUP : ""); // 分组
				localStorage.setItem("roleinfo", item.roleinfo); //角色
				localStorage.setItem("token", item.Token);
				localStorage.setItem("loginType", '0');
				localStorage.setItem("remoteLoginAccount", values.remoteLoginAccount ? values.remoteLoginAccount : ""); // 用户名
				localStorage.setItem("loginHospitalName", values.loginHospitalName ? values.loginHospitalName : ""); // 密码
				const data = JSON.parse(localStorage.getItem("settingValues")); //本地配置

				localStorage.setItem("VERSION", item.VERSION ? item.VERSION : ""); // 版本号
				if (!data) {
					var settingValues = {
						automaticApply: [],
						automaticConsult: "",
						automaticCompleteConsult: [],
						waitImproved: false,
						msgType: ["有新会诊到达消息", "会诊完成消息"],
						apply: "1",
						consulation: "1",
						printingType: "会诊医院",
						refresh: "2",
						hospitalNumber: "病历号",
						hospitalDateTime: "申请日期",
						signatureType: "电子签名",
						referralApplyTime: "1",
						referralConsultTime: "1"
					};
					localStorage.setItem("settingValues", JSON.stringify(settingValues));
				}

				if (values.remoteLoginRemember) {
					localStorage.setItem("remoteLoginPassword", values.remoteLoginPassword ? values.remoteLoginPassword : ""); // 记住密码
				} else {
					localStorage.removeItem("remoteLoginPassword"); // 不记住密码
				}
				this.initUserInfoData(); //用户基本信息
			} else {
				requestErrorLog('', '医联体登录报错', 0, true)
			}
		});
	};

	handleHospitalSearch = (value) => {
		if (value) {
			let data = this.state.hospitalData.filter((item) => {
				return item.hospital.indexOf(value) > -1;
			});
			this.setState({ hospitalNameList: data });
		} else {
			this.setState({ hospitalNameList: [] });
		}
	};

	render() {
		const { getFieldDecorator } = this.props.form;
		const { hospitalNameList } = this.state;
		const hospitalName = localStorage.getItem("loginHospitalName");
		const formItemLayout = {
			labelCol: {
				sm: { span: 5 }
			},
			wrapperCol: {
				sm: { span: 17 }
			}
		};
		const tailFormItemLayout = {
			wrapperCol: {
				sm: {
					span: 17,
					offset: 5
				}
			}
		};
		return (
			<div className="login_wrap">
				<div className="pagePic">
					<img alt="" src={require("@/assets/image/logoTitle.png").default} />
				</div>

				<Form {...formItemLayout} className="login_form">
					<div className="login_title">{this.state.loginType === 0 ? "用户登录" : "运营登录"}
						<div onClick={() => {
							this.setState({
								loginType: this.state.loginType === 0 ? 1 : 0
							})
						}} className="turnButton"><span>{this.state.loginType === 0 ? '营' : '医'}</span></div>
					</div>
					{
						this.state.loginType === 0 ? <Form.Item label={<span className="titleType">医院名称</span>}>
							{getFieldDecorator("loginHospitalName", {
								initialValue: hospitalName,
								rules: [{ required: this.state.loginType === 0 ? true : false, message: "请选择医院！" }]
							})(
								<Select
									showSearch
									placeholder="请选择医院"
									size="large"
									// suffixIcon={<Icon type="home" style={{ fontSize: '16px' }} />}
									defaultActiveFirstOption={false}
									onSearch={this.handleHospitalSearch}
									showArrow={false}
									filterOption={false}
									notFoundContent={null}>
									{hospitalNameList.map((item) => {
										return (
											<Option key={item.hospital_code} value={item.hospital}>
												{item.hospital}
											</Option>
										);
									})}
								</Select>
							)}
						</Form.Item> : null
					}
					<Form.Item label={<span className="titleType">用户名</span>}>
						{getFieldDecorator("remoteLoginAccount", {
							rules: [{ required: true, message: "用户名不能为空！" }]
						})(
							<Input
								prefix={<img alt="" src={require("@/assets/image/user.png").default} />}
								placeholder={this.state.loginType === 0 ? "用户名" : "请输入手机号"}
								size="large"
							/>
						)}
					</Form.Item>

					<Form.Item label={<span className="titleType">密码</span>}>
						{getFieldDecorator("remoteLoginPassword", {
							rules: [{ required: true, message: "密码不能为空！" }]
						})(
							<Input.Password
								prefix={<img alt="" src={require("@/assets/image/pass.png").default} />}
								placeholder="密码"
								size="large"
							/>
						)}
					</Form.Item>
					<Form.Item {...tailFormItemLayout}>
						{getFieldDecorator("remoteLoginRemember", {
							valuePropName: "checked",
							initialValue: true
						})(<Checkbox>记住密码</Checkbox>)}
					</Form.Item>
					<Form.Item {...tailFormItemLayout} className="loginBtn">
						<Button type="primary" htmlType="submit" size="large" onClick={this.handleLoginSubmit}>
							登录
						</Button>
					</Form.Item>
				</Form>
			</div>
		);
	}
}
export default Form.create({})(Login);
